// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".building-logo {\n    padding-bottom: 15px;\n}\n\n.building-logo img {\n    max-width: 100%;\n    max-height: 100%;\n    margin: auto;\n    width: auto;\n}", ""]);
// Exports
module.exports = exports;
